export const STORE_JOIN_PREDATA = 'STORE_JOIN_PREDATA';
export const CLEAR_JOIN_PREDATA = 'CLEAR_JOIN_PREDATA';

interface STORE_JOIN_PREDATA_ACTION {
  type: typeof STORE_JOIN_PREDATA;
  payload: any;
}

interface CLEAR_JOIN_PREDATA_ACTION {
  type: typeof CLEAR_JOIN_PREDATA;
  payload: any;
}

export type JoinActionTypes = STORE_JOIN_PREDATA_ACTION | CLEAR_JOIN_PREDATA_ACTION;
